import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/greenbow-logo.png")